import { translate } from "app/filters/i18nFilter";
import type { CrmField } from "app/pages/sales-intelligence/domain/leads/types/filter-options";

export const getChipDisplayText = (
    fieldName: string,
    fieldValue: string,
    fields: readonly CrmField[],
    fieldLabels: Record<string, string>,
): string => {
    const field = fields.find((f) => f.fieldName === fieldName);
    const mapping = field?.fieldValuesMap?.find((m) => m.key === fieldValue);

    const valueLabel =
        mapping?.value || fieldValue || translate("si.lead_gen_filters.category.exclude.crm.dropdown.blank");

    return `${fieldLabels[fieldName]}: ${valueLabel}`;
};

export const getAggregatedChipText = (
    fieldName: string,
    fieldValues: readonly string[],
    fields: readonly CrmField[],
    fieldLabels: Record<string, string>,
): string => {
    const field = fields.find((f) => f.fieldName === fieldName);
    const firstNotEmptyValue = fieldValues.find((c) => c);
    const mapping = field?.fieldValuesMap?.find((m) => m.key === firstNotEmptyValue);

    const valueLabel = mapping?.value ?? translate("si.lead_gen_filters.category.exclude.crm.dropdown.blank");
    return `${fieldLabels[fieldName]}: ${valueLabel} +${fieldValues.length - 1} ${translate("si.lead_gen_filters.category.exclude.crm.aggregated_chip.postfix")}`;
};

export const getAllChipText = (fieldName: string, fieldLabels: Record<string, string>): string => {
    return `${fieldLabels[fieldName]}: ${translate("si.lead_gen_filters.category.exclude.crm.dropdown.all_items")}`;
};
